import React from "react";

const TextContext = React.createContext({});

export default TextContext;
